<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 17:57:21
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 18:19:03
-->
<template>
  <span class="yx-pingfang-semibold" :class="statusObj.styleClass">{{statusObj.label}}</span>
</template>
<script>
import {spreadStatus} from '@/utils/dataMap';
import mixin from './mixin';
export default {
  mixins: [mixin],
  computed: {
    statusObj() {
      return spreadStatus[+this.cellValue]
    }
  }
}
</script>